import React from "react";

const STATUS_STYLES = {
  approved:  { background: "#dbeafe", color: "#1e40af", border: "1px solid #bfdbfe" },
  initial:   { background: "#eff6ff", color: "#1e40af", border: "1px solid #dbeafe" },
  pending:   { background: "#fef3c7", color: "#92400e", border: "1px solid #fde68a" },
  cancelled: { background: "#fee2e2", color: "#b91c1c", border: "1px solid #fecaca" },
  cancled:   { background: "#fee2e2", color: "#b91c1c", border: "1px solid #fecaca" },
};

const StatusChip = ({ status }) => {
  const normalized = status === "cancled" ? "cancelled" : (status || "initial");
  const s = STATUS_STYLES[normalized] || STATUS_STYLES.initial;
  return (
    <span style={{
      ...s,
      fontSize: 11,
      padding: "2px 8px",
      borderRadius: 10,
      fontWeight: 500,
      textTransform: "lowercase",
      letterSpacing: "0.3px",
      marginLeft: 8,
      display: "inline-block",
    }}>
      {normalized}
    </span>
  );
};

export default StatusChip;
